import { defaultDateFormat, format, yesterday, differenceInDays, isAfter, isBefore, isSame, isValid } from '../../../utils/date';

const isExceedMaxPeriod = (from, to, maxPeriod) => (
  (differenceInDays(to, from) + 1) > maxPeriod);

const isLeastMinPeriod = (from, to, minSelectablePeriod = 0) => (
  (differenceInDays(to, from) + 1) < minSelectablePeriod);

export const isFormValid = (from, to, maxDate, maxSelectablePeriod, minSelectablePeriod) => (
  isValid(from) && isValid(to)
  && (isAfter(to, from) || isSame(from, to))
  && !isAfter(from, maxDate)
  && !isAfter(to, maxDate)
  && !isExceedMaxPeriod(from, to, maxSelectablePeriod)
  && !isLeastMinPeriod(from, to, minSelectablePeriod));

export const validateOnBlur = (from, to, {
  type,
  minDate,
  maxDate,
  maxSelectablePeriod,
  minSelectablePeriod,
}) => {
  let errorMessage;
  let customType = type;

  if ((type === 'from' && !isValid(from)) || (type === 'to' && !isValid(to))) {
    errorMessage = `Use the following date format: ${defaultDateFormat.toLowerCase()}`;
  }

  const maxDateName = isBefore(maxDate, yesterday()) ? 'max allowed Date' : 'Today';

  if (type === 'from' && isAfter(from, maxDate)) errorMessage = `From Date must be before ${maxDateName}`;

  if (type === 'to' && isAfter(to, maxDate)) errorMessage = `To Date must be before ${maxDateName}`;

  if (from && to) {
    if (isExceedMaxPeriod(from, to, maxSelectablePeriod)) {
      errorMessage = `Period may not exceed ${maxSelectablePeriod} days`;
    }

    if (isLeastMinPeriod(from, to, minSelectablePeriod)) {
      errorMessage = 'Date selection must be at least four calendar weeks.';
      customType = 'minPeriodError';
    }

    if (isAfter(from, to)) {
      errorMessage = 'From Date must be before To Date';
    }
  }

  if (from && isBefore(from, minDate)) {
    errorMessage = `Starting date exceeds earliest available date of ${format(minDate)}`;
  }

  return errorMessage ? { [customType]: errorMessage } : {};
};
